/**
 * 指定したキーのメッセージを取得する
 * @param i18n i18nオブジェクト
 * @param key リソースキー
 * @returns 取得したメッセージ
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getMessage = (i18n: any, key: string) => i18n.t(key)

export {
  getMessage, // メッセージ取得
}
